var map = {
	"./activity-gift.png": 34947,
	"./airdrop-invite.png": 63821,
	"./airdrop-status-ended.png": 86853,
	"./airdrop-status-notStarted.png": 87142,
	"./airdrop-status-pedding.png": 46570,
	"./airdrop-status-prizedrawm.png": 18531,
	"./airdrop-time.png": 55355,
	"./arena-head-left.png": 53629,
	"./arena-head-right.png": 52012,
	"./arena-head-s.png": 45065,
	"./arena-head-v.png": 70375,
	"./award_tip.png": 96062,
	"./battle-defeat-bg.png": 72834,
	"./battle-head-attack-bg.png": 94628,
	"./battle-head-defender-bg.png": 95658,
	"./battle-head-vs.png": 79395,
	"./battle-icon-honor.png": 67051,
	"./battle-icon-power.png": 57727,
	"./battle-record-icon-defeat.png": 70325,
	"./battle-record-icon-victory.png": 58176,
	"./battle-victory-bg.png": 56616,
	"./battle-victory-crown.png": 9791,
	"./battle-victory-ribbon.png": 4493,
	"./battle-victory-text.png": 80590,
	"./battle-victory-wing.png": 54943,
	"./battleEffect/0.png": 61336,
	"./battleEffect/1.png": 13889,
	"./battleEffect/2.png": 3347,
	"./btn-activity-bg.png": 53669,
	"./btn-airdrop-bg.png": 59540,
	"./btn-airdrop.png": 85135,
	"./btn-close.png": 81554,
	"./btn-draw-1-bg.png": 81405,
	"./btn-draw-2-bg.png": 34557,
	"./btn-draw-3-bg.png": 23192,
	"./btn-draw-one.png": 6219,
	"./btn-draw-ten.png": 66006,
	"./btn-join-bg.png": 51838,
	"./btn-jump.png": 67643,
	"./btn-mint.png": 74765,
	"./btn-pay-bg.png": 56758,
	"./btn-pay-diamond-info.png": 43680,
	"./btn-shop-bg.png": 69565,
	"./btn-task-bg.png": 88633,
	"./btn-upgrade-bg.png": 60186,
	"./btn-upgrade-star-bg.png": 91594,
	"./card-back.png": 46269,
	"./chip-1.png": 87422,
	"./chip.png": 55531,
	"./daily-icon-card.png": 28086,
	"./daily-icon-info.png": 89714,
	"./daily-icon-ok.png": 46281,
	"./diamond-1.png": 1909,
	"./diamond-2.png": 33627,
	"./diamond-3.png": 92003,
	"./diamond-4.png": 91993,
	"./enery_invite.png": 60547,
	"./friend-btn-copy.png": 39114,
	"./friend-btn-invite.png": 57443,
	"./guide-hand.png": 46760,
	"./icon-ads.png": 32007,
	"./icon-airdop-invite.png": 18861,
	"./icon-airdrop.png": 47003,
	"./icon-anim-upgrade.png": 91082,
	"./icon-anim-upgrade_1.png": 24292,
	"./icon-arena-filter.png": 10646,
	"./icon-arena-lock.png": 32506,
	"./icon-arena-power.png": 17877,
	"./icon-arena-record.png": 71527,
	"./icon-arena.png": 93876,
	"./icon-copy.png": 50710,
	"./icon-diamonds.png": 26987,
	"./icon-energy.png": 78163,
	"./icon-gold.png": 16404,
	"./icon-info.png": 90563,
	"./icon-invite.png": 90142,
	"./icon-mint.png": 34464,
	"./icon-pay.png": 74084,
	"./icon-power-new.png": 70946,
	"./icon-power.png": 45668,
	"./icon-question.png": 81433,
	"./icon-quit.png": 56423,
	"./icon-ranking.png": 27976,
	"./icon-record.png": 79325,
	"./icon-shop.png": 92062,
	"./icon-task.png": 88515,
	"./icon-time.png": 45747,
	"./icon-ton.png": 48514,
	"./icon-usdt.png": 22130,
	"./icon-wallet.png": 98418,
	"./item-bg.png": 86269,
	"./item-level.png": 26714,
	"./join-g.png": 3391,
	"./light.png": 89937,
	"./menu-arena-active1.png": 88422,
	"./menu-arena.png": 60742,
	"./menu-assets-active1.png": 34854,
	"./menu-assets.png": 39699,
	"./menu-backpack-active1.png": 98719,
	"./menu-backpack.png": 32911,
	"./menu-friend-active1.png": 22359,
	"./menu-friend.png": 20860,
	"./menu-home-active1.png": 3098,
	"./menu-home.png": 95847,
	"./menu-mining-active1.png": 70331,
	"./menu-mining.png": 24539,
	"./menu-rank-active1.png": 5365,
	"./menu-rank.png": 20918,
	"./mining/logo/binance.png": 27528,
	"./mining/logo/bitget.png": 13230,
	"./mining/logo/gate.png": 16745,
	"./mining/logo/okx.png": 25078,
	"./mining/logo/stonfi.png": 37696,
	"./mining/mining-q-1.png": 67973,
	"./mining/mining-q-2.png": 90082,
	"./mining/mining-q-3.png": 24831,
	"./mining/mining-q-4.png": 33338,
	"./mining/mining-q-5.png": 46265,
	"./name-bg.png": 20111,
	"./nav-btn-bg-1.png": 21829,
	"./nav-btn-bg-2.png": 17809,
	"./nav-btn-bg-3.png": 67157,
	"./nav-btn-bg-4.png": 66227,
	"./pony.png": 39467,
	"./ponyverse.png": 28383,
	"./pop-btn-upgrade-bg.png": 36521,
	"./pop-btn-upgrade-star-bg.png": 27631,
	"./pop-upgrade-arrow.png": 17091,
	"./pop-upgradestar-star-bg.png": 71262,
	"./rank-1.png": 84089,
	"./rank-2.png": 987,
	"./rank-3.png": 27269,
	"./rarity-1.png": 29030,
	"./rarity-2.png": 45760,
	"./rarity-3.png": 12668,
	"./rarity-4.png": 53777,
	"./rarity-5.png": 91389,
	"./rarity-bg.png": 78347,
	"./rarity-text-1.png": 90363,
	"./rarity-text-2.png": 59497,
	"./rarity-text-3.png": 1183,
	"./rarity-text-4.png": 38987,
	"./rarity-text-5.png": 42662,
	"./reward-card-img.png": 39393,
	"./reward-coin-img.png": 64758,
	"./reward-coin-question.png": 72346,
	"./reward-icon-watch.png": 94117,
	"./reward-pony-img.png": 50965,
	"./reward-usdt-img.png": 1089,
	"./star-bg.png": 37773,
	"./star.png": 94008
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57046;